/** Dataobjects: attributes, relations, views, quick-add and Graphly mapping. */

export default {
	dataobjects: {
		empty: {
			title: "Noch keine Datenobjekte",
		},
		delete: "Datenobjekt löschen",
		deleteConfirm:
			"„{name}“ aus dem Informationsmodell löschen? Das lässt sich nicht rückgängig machen.",
		loading: "Informationsmodell wird gelesen…",
		undoShortcut: "Zuletzt gelöschtes Attribut oder gelöschte Beziehung wiederherstellen",
		undoAlt: "Rückgängig: {key} drücken",
		// Der Axiom-Editor — ein Dialog, der ein Attribut aus benannten Prämissen ableitet.
		axiom: {
			title: "Axiom",
			titleNew: "Neues Axiom",
			note: "Leitet dieses Attribut aus den Prämissen ab, die Sie benennen. Die Fälle werden von oben nach unten geprüft — der erste, der zutrifft, setzt den Wert.",
			noteReadOnly:
				"Leitet dieses Attribut aus den Prämissen unten ab. Die Fälle werden von oben nach unten geprüft — der erste, der zutrifft, setzt den Wert.",
			// A project type is a closed set of values — the "option" kind of the type field.
			typeOption: "Auswahl · {name}",
			readOnly: "Schreibgeschützt",
			noPermission: "Zum Bearbeiten ist die Berechtigung „Axiome · Schreiben“ nötig.",
			premises: {
				title: "Prämissen",
				hint: "Was die Fälle lesen können",
				add: "Prämisse hinzufügen",
				name: "Name der Prämisse",
				namePlaceholder: "Name",
				nameRequired: "Geben Sie dieser Prämisse einen Namen",
				nameDuplicate: "Eine andere Prämisse hat schon diesen Namen",
				remove: "Prämisse {name} entfernen",
				removeUnnamed: "Unbenannte Prämisse entfernen",
				chooseHop: "Attribut oder Beziehung wählen",
				chooseFrom: "aus {name} wählen",
				changeHop: "{name} ändern",
				usedBy: "Verwendet von Fall {cases} | Verwendet von den Fällen {cases}",
				unused: "Noch von keinem Fall verwendet",
				emptyTitle: "Noch keine Prämissen",
				emptyBody:
					"Eine Prämisse gibt einem Wert einen kurzen Namen, damit die Fälle ihn prüfen können — die Summe der Bestellung oder address.country ihres Kunden.",
			},
			cases: {
				title: "Fälle",
				hint: "von oben nach unten geprüft, der erste Treffer gilt",
				add: "Fall hinzufügen",
				colWhen: "Wenn",
				colThen: "Dann ist {name}",
				always: "Immer",
				kind: "Art des Falls",
				kindSet: "Wert setzen",
				kindCalc: "Berechnen",
				duplicate: "Fall {n} duplizieren",
				remove: "Fall {n} entfernen",
				collapse: "Fall {n} einklappen",
				expand: "Fall {n} bearbeiten",
				move: "Fall {n} verschieben",
				moveHint: "Ziehen oder {key}+↑↓",
				when: "Wenn",
				onlyWhen: "Nur wenn",
				onlyWhenHint: "optional — leer lassen, damit er immer gilt",
				combine: "Bedingungen verknüpfen",
				and: "und",
				or: "oder",
				removeCondition: "Bedingung entfernen",
				premise: "Prämisse",
				check: "Prüfung",
				valueFor: "Wert für {name}",
				noValue: "kein Wert nötig",
				setTo: "Dann {name} setzen auf",
				pickValue: "Wert wählen",
				calcAs: "{name} berechnen als",
				insert: "Einfügen",
				exprHint: "Ein TypeScript-Ausdruck; Prämissen sind über ihren Namen verfügbar.",
				writeBack: "Zurückschreiben",
				writeBackMeta: "optional · {set} von {total} gesetzt",
				writeBackBody:
					"Wenn jemand {name} direkt bearbeitet, wird jede Prämisse daraus aktualisiert. Verwenden Sie {target} für den neuen Wert und {others} für die anderen Prämissen. Lassen Sie eine Zeile leer, um die Prämisse unverändert zu lassen.",
				writeBackTo: "Zurückschreiben nach {name}",
				keep: "unverändert lassen",
				nothingMatched: "Nichts trifft zu",
				unreachable: "Nichts trifft zu — unerreichbar, Fall {n} gilt immer",
				staysEmpty: "{name} bleibt leer",
				emptyTitle: "Jeder Fall ist eine Zeile der Regel",
				emptyBody:
					"Ein Fall setzt {name} entweder auf einen festen Wert, wenn seine Bedingungen zutreffen, oder berechnet ihn aus den Prämissen.",
				problems: {
					needsValue: "Wert wählen",
					needsExpression: "Ausdruck eingeben",
					conditionIncomplete: "Bedingungen vervollständigen",
				},
			},
			select: {
				which: "Welches Element von {name}",
				first: "erstes",
				second: "zweites",
				third: "drittes",
				nth: "Element {n}",
				find: "wo…",
				findLabel: "das, bei dem…",
			},
			addCondition: {
				title: "Bedingung hinzufügen",
				premise: "Prämisse",
				check: "Prüfung",
				hint: "Es werden nur die Prüfungen angeboten, die zu {kind} passen.",
				add: "Hinzufügen",
				noPremises: "Benennen Sie zuerst eine Prämisse",
			},
			selectEditor: {
				title: "Welches Element von {name}",
				mode: "Auswählen nach",
				byPosition: "Position",
				byCondition: "Bedingung",
				where: "Wo",
				noAttributes: "{name} hat keine Attribute, die sich prüfen lassen.",
			},
			remove: "Axiom entfernen",
			removeConfirm:
				"Das Axiom auf „{name}“ entfernen? Das lässt sich nicht rückgängig machen.",
			save: "Axiom speichern",
			create: "Axiom anlegen",
			block: {
				noPremises: "Fügen Sie eine Prämisse hinzu, um zu speichern",
			},
			fix: {
				count: "{n} zu beheben:",
				premiseName: "Prämisse {n} braucht einen Namen",
				premiseDuplicate: "Prämisse {n} hat einen doppelten Namen",
				premisePath: "Prämisse {n} braucht einen vollständigen Pfad",
				premiseSelector: "Prämisse {n} braucht ein fertiges „wo“",
				caseValue: "Fall {n} braucht einen Wert",
				caseExpression: "Fall {n} braucht einen Ausdruck",
				caseCondition: "Fall {n} hat eine unfertige Bedingung",
				unsaved: "Ungespeicherte Änderungen",
			},
		},
		attributes: {
			deleted: "Attribut „{name}“ gelöscht",
			title: "Attribute",
			type: "Typ",
			toggleOptional: "Optionales Attribut (klicken, um erforderlich zu machen)",
			toggleRequired: "Erforderliches Attribut (klicken, um optional zu machen)",
			toggleArray: "Werteliste (klicken, um sie zum Einzelwert zu machen)",
			toggleScalar: "Einzelwert (klicken, um ihn zur Werteliste zu machen)",
			optionalOnList:
				"Eine Liste von Datenobjekten ist nie optional: Eine leere Liste bedeutet bereits „keine“.",
			optionalForCycle:
				"Dieser Typ enthält dieses Datenobjekt wieder, daher muss ein Einzelwert optional sein — oder machen Sie eine Liste daraus.",
			listOrOptional: "nur [] oder ?",
			openTypeHint: "{key}-Klick öffnet ihn unter Datentypen",
			empty: "Noch keine Attribute.",
			delete: "Attribut löschen",
			openAxiom: "Axiom konfigurieren",
		},
		relations: {
			addTitle: "Beziehung hinzufügen",
			deleted: "Beziehung „{name}“ gelöscht",
			title: "Beziehungen",
			label: "Bezeichnung der Beziehung",
			target: "Ziel",
			empty: "Noch keine Beziehungen.",
			dragHint:
				"Um eine Beziehung hinzuzufügen, ziehen Sie dieses Datenobjekt mit gedrückter {key}-Taste auf ein anderes.",
			incoming: "Eingehende Beziehungen",
			incomingJump: "Zum Datenobjekt springen, das diese Beziehung deklariert",
			incomingHint:
				"Schreibgeschützt. Eine eingehende Beziehung bearbeiten Sie an dem Datenobjekt, das sie deklariert.",
			delete: "Beziehung löschen",
			deleteConfirm: "Beziehung „{name}“ löschen?",
			quickAdd: {
				placeholder: "name: Ziel",
				parseError: "Eingabe nicht lesbar — erwartet name: Ziel",
				unknownTarget: "Unbekanntes Datenobjekt „{target}“",
				pickTarget: "Ziel im Menü wählen oder „: Datenobjekt“ anhängen",
				groupFromTarget: "Aus Ziel anlegen",
			},
		},
		centerGraph: "Graph zentrieren",
		permissions: {
			readOnly: "Schreibgeschützt",
			readOnlyTooltip:
				"Sie haben keine Berechtigung, Datenobjekte oder diese Ansicht zu bearbeiten.",
			dataobjectsReadOnly: "Datenobjekte schreibgeschützt",
			dataobjectsReadOnlyTooltip:
				"Sie können diese Ansicht neu anordnen, aber keine Datenobjekte bearbeiten.",
			viewLocked: "Ansicht gesperrt",
			viewLockedTooltip:
				"Sie können Datenobjekte bearbeiten, aber diese Ansicht nicht verändern.",
			sidebarHint: "Sie haben keine Berechtigung, Datenobjekte zu bearbeiten.",
		},
		sidebar: {
			idleHint:
				"Datenobjekt auf die Leinwand ziehen oder per Doppelklick auf die Leinwand hinzufügen.",
			idleHintReadOnly:
				"Alle Datenobjekte dieses Projekts — Sie haben keine Berechtigung, diese Ansicht zu ändern.",
		},
		changeColor: "Farbe ändern",
		create: {
			title: "Datenobjekt hinzufügen",
			named: "„{name}“ erstellen",
			notAllowed: "Erstellen von Datenobjekten nicht erlaubt",
			notAllowedTooltip:
				"Sie haben keine Berechtigung, Datenobjekte in diesem Projekt zu erstellen.",
			searchOrCreateLabel: "Suchen oder zum Erstellen eine Bezeichnung eingeben…",
			noResults: "Keine Ergebnisse",
		},
		quickAdd: {
			placeholder: "name: typ[]?",
			parseError: "Eingabe nicht lesbar — erwartet name: typ[]?",
			unknownType: "Unbekannter Typ „{type}“",
			createHint: "{name} anlegen",
			pickType: "Typ im Menü wählen oder „: Typname“ anhängen",
			existsHint: "existiert bereits — Enter springt zur Zeile",
			groupExists: "Existiert bereits",
			groupFromType: "Aus Typ anlegen",
			keys: {
				accept: "übernehmen",
				create: "anlegen",
				choose: "wählen",
				close: "schließen",
			},
		},
		tabs: {
			label: "Datenobjekt-Eigenschaften",
			graphly: "Graphly",
		},
		graphly: {
			templateUrl: "Template-URL",
			templatePlaceholder: "https://cdn.graphly.dev/...",
			templateHostNotAllowed:
				"Host nicht zugelassen — verwenden Sie die CDN-URL des Templates (https://cdn.graphly.dev/…).",
			visitTemplate: "Template ansehen",
			browseTemplates: "Templates durchsuchen",
			fieldMapping: "Feldzuordnung",
			mapAttribute: "Attribut zuordnen…",
			defaultValue: "Standardwert",
			/* Under a mapped field's default: when the shape shows it instead of the attribute. */
			defaultWhileUnset:
				"Wird angezeigt, solange das Attribut nicht gesetzt oder nicht gültig ist",
			boolTrue: "Wahr",
			boolFalse: "Falsch",
			/* An enum value that is the empty string, as the template allows it. */
			enumEmpty: "(leer)",
			noFields: "Dieses Template enthält keine Payload-Felder.",
		},
	},
	fields: {
		tags: "Tags",
		tagsPlaceholder: "Tags hinzufügen…",
		tagsCreate: "„{tag}“ hinzufügen",
		tagsEmpty: "Keine passenden Tags",
	},
	views: {
		create: "Neue Ansicht",
		edit: "Ansicht bearbeiten",
		name: "Ansichtsname",
		search: "Ansichten suchen…",
		noResults: "Keine Ansichten entsprechen Ihrer Suche.",
		empty: {
			title: "Noch keine Ansichten",
			hint: "Erstellen Sie eine Ansicht, um Ihr Informationsmodell zu visualisieren.",
		},
		deleteConfirm: "Ansicht „{name}“ löschen?",
		removeDataobject: "Aus Ansicht entfernen",
		removeDataobjectConfirm:
			"„{name}“ aus dieser Ansicht entfernen? Es bleibt im Informationsmodell erhalten.",
		picker: {
			search: "Suchen",
			available: "Verfügbar",
			alreadyIn: "Bereits in Ansicht",
			noMatches: "Keine Treffer",
		},
	},
};
